import React from 'react'
import { LucideIcon } from 'lucide-react'
import { clsx } from 'clsx'

export type StatTileTone = 'primary' | 'accent' | 'success' | 'warning' | 'neutral'

interface StatTileProps {
  title: string
  value: string | number
  icon: LucideIcon
  tone?: StatTileTone
  className?: string
}

const toneClasses: Record<StatTileTone, { bg: string; icon: string; value: string; label: string }> = {
  primary: {
    bg: 'bg-gradient-to-br from-primary-100 to-primary-200',
    icon: 'text-primary-700',
    value: 'text-primary-900',
    label: 'text-primary-800'
  },
  accent: {
    bg: 'bg-gradient-to-br from-accent-100 to-accent-200',
    icon: 'text-accent-800',
    value: 'text-accent-900',
    label: 'text-accent-800'
  },
  success: {
    bg: 'bg-gradient-to-br from-green-50 to-green-100',
    icon: 'text-green-700',
    value: 'text-green-900',
    label: 'text-green-800'
  },
  warning: {
    bg: 'bg-gradient-to-br from-amber-50 to-amber-100',
    icon: 'text-amber-700',
    value: 'text-amber-900',
    label: 'text-amber-800'
  },
  neutral: {
    bg: 'bg-gradient-to-br from-gray-100 to-gray-200',
    icon: 'text-gray-700',
    value: 'text-gray-900',
    label: 'text-gray-700'
  }
}

export const StatTile: React.FC<StatTileProps> = ({ title, value, icon: Icon, tone = 'neutral', className }) => {
  const colors = toneClasses[tone]

  return (
    <div className={clsx('rounded-3xl p-6 flex flex-col gap-4', colors.bg, className)}>
      <div className="w-11 h-11 rounded-full bg-white/70 flex items-center justify-center">
        <Icon className={clsx('w-5 h-5', colors.icon)} />
      </div>
      <div>
        <p className={clsx('text-2xl font-extrabold', colors.value)}>{value}</p>
        <p className={clsx('text-sm font-semibold', colors.label)}>{title}</p>
      </div>
    </div>
  )
}

export default StatTile
